import { reduce } from "et3-type-guards";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../../core/et3-input/et3-text-input";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import { TalkhattabatConversationType } from "../../../../../../Types";
import { khattabaConversationParsing } from "../../../../../../helpers/et3-conversation-parse";

const MessageInputField = withLiteObserverAndTheme<{
  conversationID: string;
  oneOTwoConversationId: string;
  alkhattabaUUID: string;
  userUUID: string;
  peerID: number;
  userID: number;
  peerUUID: string;
  conversationType: TalkhattabatConversationType;
  oneOOneCId: string;
}>((props) => {
  const {
    theme,
    conversationID,
    oneOTwoConversationId,
    alkhattabaUUID,
    userUUID,
    peerID,
    peerUUID,
    conversationType,
    userID,
    oneOOneCId
  } = props;
  const { colors, unitX, unitY } = theme;

  const alkhattabaText = reduce(
    () =>
      getKhattabatStore().conversationsProps.get(conversationID).messageField,
    ""
  );
  const isOneOOneCConversation = conversationType === "101C";
  const isOneOOneMConversation = conversationType === "101M";
  const isOneOOneCComment = conversationType === "101C_COMMENTS";
  const isOneOOneMComment = conversationType === "101M_COMMENTS";

  return (
    <ET3Div
      width={985}
      height={40}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: colors.all.white,
        borderRadius: 41 * unitX,
        cursor: "text",
        overflow: "hidden"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      <Et3TextInput
        size="LARGE"
        withShadow={false}
        placeHolder={"Type Here"}
        icon={"function"}
        label={""}
        style={{
          width: 985 * unitX,
          maxHeight: 40 * unitY
        }}
        value={reduce(
          () =>
            getKhattabatStore().conversationsProps.get(conversationID)
              .messageField,
          ""
        )}
        onChoose={(fieldValue: string) => {
          const parsedText = khattabaConversationParsing(fieldValue);
          getKhattabatStore().updateConversationProp({
            value: parsedText,
            propKey: "messageField",
            conversationID
          });
        }}
        onBlur={() => {}}
        type={"text"}
        onEnter={() => {
          const alkhattabaParsedText =
            khattabaConversationParsing(alkhattabaText);
          switch (true) {
            case isOneOOneCConversation:
              return getKhattabatStore().sendOneOMessageDatabase({
                alkhattabaUUID,
                userUUID,
                alkhattabaText: alkhattabaParsedText,
                conversationID,
                userID,
                conversationType,
                oneOOneCId
              });
            case isOneOOneMConversation:
            case isOneOOneMComment:
              return getKhattabatStore().sendOneOMessageDatabase({
                alkhattabaUUID,
                userUUID: peerUUID,
                alkhattabaText: alkhattabaParsedText,
                conversationID,
                userID: peerID,
                conversationType,
                oneOOneCId
              });
            case isOneOOneCComment:
              return getKhattabatStore().sendOneOMessageDatabase({
                alkhattabaUUID,
                userUUID,
                alkhattabaText,
                conversationID,
                userID,
                conversationType,
                oneOOneCId
              });
            default:
              return getKhattabatStore().sendOneTwoMessageDatabase({
                alkhattabaUUID,
                userUUID,
                userID,
                alkhattabaText: alkhattabaParsedText,
                peerID,
                peerUUID,
                conversationID,
                oneOTwoConversationId,
                oneOOneCId
              });
          }
        }}
      />
    </ET3Div>
  );
});

export default MessageInputField;
